<ul class="pagination mt-5 justify-content-end" *ngIf="data.last_page !== 1">
  <li class="page-item" [ngClass]="!data.prev_page_url ? 'disabled':''">
    <a href="javascript:;" *ngIf="!filter" class="page-link" (click)="loadData(data.prev_page_url)">← &nbsp; Prev</a>
    <a href="javascript:;" *ngIf="filter" class="page-link" (click)="loadData(data.prev_page_url+'&search='+filter)">← &nbsp; Prev</a>
  </li>
  <li class="page-item" [ngClass]="page_number == data.current_page ? 'active':''" *ngFor="let page_number of childPagination">
    <a *ngIf="page_number !== ' ... ' && !filter" href="javascript:;" (click)="loadData(data.path+'?page='+page_number)" class="page-link">{{page_number}}</a>
    <a *ngIf="page_number !== ' ... ' && filter" href="javascript:;" (click)="loadData(data.path+'?search='+filter+'&page='+page_number)" class="page-link">{{page_number}}</a>
    <a *ngIf="page_number === ' ... '" href="javascript:;" class="page-link">{{page_number}}</a>
  </li>
  <li class="page-item" [ngClass]="!data.next_page_url ? 'disabled':''">
    <a href="javascript:;" *ngIf="!filter" class="page-link" (click)="loadData(data.next_page_url)">Next &nbsp; →</a>
    <a href="javascript:;" *ngIf="filter" class="page-link" (click)="loadData(data.next_page_url+'&search='+filter)">Next &nbsp; →</a>
  </li>
</ul>
